package er.prateek.crossly.data.model

import kotlinx.serialization.Serializable

/**
 * The playable game modes. [CROSSWORD] is the original word crossword; the two math modes are
 * procedurally generated at runtime (see `generation/math` and `generation/riddle`).
 *
 * [wireType] matches the long-standing `type` string on [CrosswordPack]/`PackManifestEntry`
 * (default `"CROSSWORD"`), so the discriminator that already travels in content JSON keeps its
 * meaning. [slug] is the short, url/id-safe prefix used when building per-mode level ids and
 * persistence keys (`math-easy-001`, `math_saved_session`).
 */
@Serializable
enum class GameMode(val slug: String, val wireType: String) {
    CROSSWORD("crossword", "CROSSWORD"),
    MATH_CROSSWORD("math", "MATH_CROSSWORD"),
    RIDDLES("riddle", "RIDDLES"),
    ;

    /**
     * The `mode` value on every analytics event: `crossword`, `math_crossword` or `riddles`. One
     * spelling everywhere, so a single filter splits any report by mode.
     */
    val analyticsName: String get() = wireType.lowercase()

    companion object {
        /** Maps a content `type` string back to a mode, defaulting to [CROSSWORD] for anything unknown. */
        fun fromWire(type: String): GameMode =
            entries.firstOrNull { it.wireType.equals(type, ignoreCase = true) } ?: CROSSWORD
    }
}
